import { Button } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import banner from './banner.png';
import './style.scss';

export interface ErrorBoxProps {
    error: Error | string;
    title?: string;
    onClick?: React.MouseEventHandler;
    btnText?: string;
}

export interface ErrorBoxState {
    loading: boolean;
}

const ErrorBox: React.FC<ErrorBoxProps> = ({ title, onClick, error, btnText }) => {
    const [isLoading, setLoading] = useState(false);
    const mountRef = useRef(false);

    useEffect(() => {
        mountRef.current = true;

        return () => {
            mountRef.current = false;
        };
    }, []);

    const errorMsg = error instanceof Error ? error.message : error;
    const onBtnClick = async ev => {
        try {
            setLoading(true);

            await onClick?.(ev);
        } catch {}

        if (mountRef.current) {
            setLoading(false);
        }
    };

    return (
        <div className="error-box-root">
            <img className="eb-banner" src={banner} alt="error-box banner" />
            {title && <h4 className="eb-title">{title}</h4>}
            <p className="error-msg">{errorMsg}</p>
            {onClick && (
                <Button
                    className="eb-btn"
                    onClick={onBtnClick}
                    type="primary"
                    size="middle"
                    loading={isLoading}
                    disabled={isLoading}>
                    {btnText ? btnText : __('重试')}
                </Button>
            )}
        </div>
    );
};

export default ErrorBox;
